import Link from 'next/link'
import {cn} from '@heroui/react'
import Image from 'next/image'

import Box from '../UI/Box/Box'

const AppStoreButton = ({className}: {className?: string}) => {
  return (
    <Link
      className="w-fit h-fit rounded-md overflow-hidden"
      href="https://apps.apple.com/tr/app/advicemy/id6478523120?l=tr">
      <Box className={cn('relative h-12 w-[182px]', className)}>
        <Image alt="advicemyGooglePlay" fill src="/app-store.png" />
      </Box>
    </Link>
  )
}

export default AppStoreButton
